module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("關於我們")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內容")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("關於我們")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("關於我們")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("我們的會員")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('article', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("關於i80")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n                        i80諧音取自「愛幫您」這個緣起於愛，我們以愛為出發點，即我幫您-您幫我。\n我們設計的不只是平台而是一種架構，在我們架構裡，沒有貧窮，也沒有人會失業，我們讓「失業與貧窮」這個詞失去意義。人不應該到企業去找工作，應該是給人工作的人。所有的人都是創業家，我們創造了更新、更好的體系。因為創業精神是人的基本特質。\n我們的宗旨就「讓每一個人都成為自己時間的主人，過自己想要的生活，做自己喜歡的事情，賺自己需要財富！」。\n                      "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("我們要如何做到?")]), _vm._v(" 我們透過店家的串聯成為一個大商圈，將消費者集結成聯盟，並創建人人都是老闆的平台。\n                      要改變傳統產業利潤分配模式，我們需要同舟共濟一起合作，相互進行商圈宣傳及舉辦活動，創造消費者和店家雙贏的局面。\n                      "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("我們該如何合作?")]), _vm._v("\n                      如果你認同我們的理念，請將我們的理念介紹給親友，讓他加入我們成為會員，成為消費者聯盟的一份子。成為會員後，到聯盟的商店購買產品即有回饋點數。\n                    ")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/PQtCtw3DP4w",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd2e7906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 322
// module chunks = 1